import React  from "react";


import {
    useGetSingleAmenityQuery,
  useUpdateAmenityMutation,
} from "../../../../features/master/amenities/amenitieApiSlice";

import { useParams } from "react-router-dom";
import EditService from "../EditServices";

export default function Index() {
    const { id } = useParams();
  const { data, refetch } = useGetSingleAmenityQuery(id);
  const [updateAmenity , {isLoading}] = useUpdateAmenityMutation();

  

  return (
    <EditService isLoading={isLoading}
          data={data}
          refetch={refetch}
          id={id}
          name={"amenities"}
          title={"Amenities"}
          updatedData={updateAmenity}
      />
  );
}
